import { useEffect, useMemo, useState } from 'react'
import { subscribeToClients } from '../../services/clientsService'
import type { Client } from '../../types/client'
import { Select } from '../Common'
import { useNls } from '../../nls/nlsProvider'

export interface GoalClientPickerProps {
  workspaceId: string
  clientId: string | null | undefined
  onChange: (clientId: string | null) => void
  disabled?: boolean
  className?: string
}

export const GoalClientPicker = ({
  workspaceId,
  clientId,
  onChange,
  disabled = false,
  className,
}: GoalClientPickerProps) => {
  const { t } = useNls()
  const [clients, setClients] = useState<Client[]>([])

  useEffect(() => {
    if (!workspaceId) return
    const unsubscribe = subscribeToClients(
      workspaceId,
      (data) => setClients(data),
      { includeArchived: false },
      () => setClients([]),
    )
    return () => unsubscribe()
  }, [workspaceId])

  const options = useMemo(() => {
    const list = [
      { value: '', label: t('NLSGoalFieldClientNone') },
      ...clients.map((c) => ({
        value: c.id,
        label: c.company ? `${c.name} (${c.company})` : c.name,
      })),
    ]
    return list
  }, [clients, t])

  return (
    <div className={className} data-testid="goal-client-picker">
      <Select
        label={t('NLSGoalFieldClient')}
        ariaLabel={t('NLSGoalFieldClient')}
        value={clientId || ''}
        options={options}
        onChange={(val) => onChange(val ? val : null)}
        disabled={disabled}
      />
    </div>
  )
}
